import { List, styled } from '@mui/material';
import { filterVisibleMenuItems } from 'helpers/layout/sidebarMenu';
import NavigationItem from './NavigationItem';
import { SidebarMenuItemType } from 'hooks/ui/useSidebarMenuItems';
import { useGetAllPermissionsList } from 'hooks/ui/usePermissions';
import { useGetRole } from 'hooks/ui/useGetRole';

const SectionWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  fontWeight: Number(theme.typography.fontWeightRegular.valueOf),
  '&:not(:first-of-type)': {
    borderTop: `solid 1px ${theme.palette.sidebar?.borderColor}`,
    marginTop: '25px',
  },
}));

const SectionHeader = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: '35px 16px 8px 32px',
  textTransform: 'uppercase',
  fontWeight: Number(theme.typography.fontWeightRegular.valueOf),
  fontSize: 10,
  letterSpacing: 1.5,
}));

type Props = {
  name: string;
  children?: Array<SidebarMenuItemType>;
};

const Section: React.FC<Props> = ({ name, children }) => {
  const permissionsList = useGetAllPermissionsList();
  const { roleSlug } = useGetRole();
  const visibleChildren = filterVisibleMenuItems(
    children ?? [],
    permissionsList,
    roleSlug,
  );

  if (!visibleChildren.length) {
    return null;
  }

  return (
    <SectionWrapper>
      <SectionHeader>{name}</SectionHeader>
      <List component="div" disablePadding>
        {visibleChildren.map((item) => (
          <NavigationItem
            item={item}
            key={`navigation-item-${item.type}-${item.name}`}
          />
        ))}
      </List>
    </SectionWrapper>
  );
};

export default Section;
